import React from 'react';
import EventEmitter from 'events';

import util from '../tools/util';
import UserStore from './user_store';

export default {
  once,
  addChangeListener,
  removeChangeListener,
  init,
  isReady,
  getOrgList,
  useOrgList,
  fetchOrg,
};

const g_listOrgMap = new Map<number, any>();

const g_eventEmitter = new EventEmitter();
const CHANGE_EVENT = 'change';
function once(callback) {
  g_eventEmitter.once(CHANGE_EVENT, callback);
}
function addChangeListener(callback) {
  g_eventEmitter.on(CHANGE_EVENT, callback);
}
function removeChangeListener(callback) {
  g_eventEmitter.removeListener(CHANGE_EVENT, callback);
}
function _emit(...args) {
  g_eventEmitter.emit(CHANGE_EVENT, ...args);
}
function init(done) {
  done && done();
}
function isReady() {
  return true;
}
function getOrgList(org_id: number) {
  return g_listOrgMap.get(org_id);
}
function _subscribe(callback: any) {
  addChangeListener(callback);
  return () => {
    removeChangeListener(callback);
  };
}
export function useOrgList(org_id: number) {
  const _get = React.useCallback(() => getOrgList(org_id), [org_id]);
  return React.useSyncExternalStore(_subscribe, _get);
}
function fetchOrg(org_id: number, done?: (err: any) => void) {
  const opts = {
    url: `/admin/1/org/${org_id}/device`,
  };
  UserStore.get(opts, (err, body) => {
    if (err) {
      util.errorLog('DeviceStore.fetch: err:', err);
    } else if (body) {
      const old = g_listOrgMap.get(org_id);
      if (!util.deepEqual(old, body.device_list)) {
        g_listOrgMap.set(org_id, body.device_list);
        _emit('update');
      }
    }
    done?.(err);
  });
}
